import { lazyLoad } from 'utils/loadable';

export const UserAdmin = lazyLoad(
  () => import('./userAdmin.page'),
  (module) => module.UserAdmin
);
